import {Card} from "@mui/material";
import React, {useEffect, useState} from "react";
import LayoutBox from "../../../reusableComponents/LayoutBox";
import Calendar from "../../../reusableComponents/Calendar copy";
import CalendarIcon from "../../../assets/icons/calender.svg";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {returnMessages} from "../../../store/reducers/message";
import {returnErrors} from "../../../store/reducers/error";
import Spinner from "../../../reusableComponents/Spinner";
import {useLocation, useNavigate} from "react-router-dom";
import {createJournalTraderRequest, getTraderJournalRequest, updateJournalTraderRequest} from "../../../utils/apis";
import {getTraderJournalSuccess} from "../../../store/reducers/accountSlice";
import CustomSeparator from "../../Breadcrumbs/Breadcrumbs";
import customStyles from "../../../customstyle/customstyle";

function parseISOString(s) {
  var b = s.split(/\D+/);
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
}
const CreateTradeJournal = () => {


  const options = [
    {value: 0, label: "Sell"},
    {value: 1, label: "Buy"},
  ];
  const options2 = [
    {value: 0, label: "Googl"},
    {value: 1, label: "AAPL"},
  ];
  const options3 = [
    {value: 0, label: "In"},
    {value: 1, label: "Out"},
  ];
  const tableDatas = useLocation();
  const [rowData, setRowData] = useState(tableDatas?.state?.data);

  const [isCalender, setIsCalender] = useState(false);
  const [counterTrend, setCounterTrend] = useState(rowData?.counter_trend || null);
  const [tradeType, setTradeType] = useState(options[1] || null);
  const [profit, setProfit] = useState(rowData?.profit || null);
  const [orderPrice, setOrderPrice] = useState(rowData?.order_price || null);
  const [max_stop_price, setMax_stop_price] = useState(rowData?.max_stop_price || null);
  const [symbol, setSymbol] = useState(rowData?.symbol || "");
  const [max_loss, setMax_loss] = useState(rowData?.max_loss || null);
  const [size, setSize] = useState(rowData?.size || null);
  const [technical_stop, settechnical_stop] = useState(rowData?.technical_stop || null);
  const [exit_target, setexit_target] = useState(rowData?.exit_target || null);
  const [system_rules, setsystem_rules] = useState(rowData?.system_rules || 1);
  const [result_in_fear, setresult_in_fear] = useState(rowData?.result_in_fear || 1);
  const [greed_or_pride, setgreed_or_pride] = useState(rowData?.greed_or_pride || 1);
  const [entry, setEntry] = useState(rowData?.entry || options3[null]);
  const [trigger, setTrigger] = useState(rowData?.trigger || "");
  const [supporting_evidence, setSupporting_evidence] = useState(rowData?.supporting_evidence || "");
  const [opposing_evidence, setOpposing_evidence] = useState(rowData?.opposing_evidence || "");
  const [heads_up, setHeads_up] = useState(rowData?.heads_up || "");
  const [notes, setNotes] = useState(rowData?.notes || "");
  const [time_stop, setTime_stop] = useState(rowData?.time_stop || "00:00");
  // const [time_stop2, setTime_stop2] = useState("");
  // const [risk_or_reward, setRisk_or_reward] = useState("");
  const [alerts_placed, setAlerts_placed] = useState(rowData?.alerts_placed || true);

  const [otp, setOtp] = useState(["", ""]);

  const handleInputChange = (index, value) => {
    if (/^\d*$/.test(value) && value.length <= 3) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
    }
  };

  const [date, setDate] = React.useState(new Date(Date.now()));

  React.useEffect(() => {
    const isoString = "2020-09-01T05:02:00.000+0000";
    const dateFromISOString = parseISOString(isoString);
    setDate(dateFromISOString);
  }, []);
  const handleChange = (dateChange) => {
    setDate(dateChange);
  };

  const handleTradeType = (select) => {
    setTradeType(options[select.value]);
  };
  useEffect(() => {
    setTradeType(rowData?.action ? {value: rowData.action === "Sell" ? 0 : 1, label: rowData.action} : options[0]);
  }, [rowData]);
  const data = {
    date: date,
    counter_trend: counterTrend,
    tradeType: tradeType.label,
    symbol: symbol,
    orderPrice: orderPrice,
    profit: profit,
    entry: entry?.label || "",
    trigger: trigger || "",
    supporting_evidence: supporting_evidence || "",
    opposing_evidence: opposing_evidence || "",
    heads_up: heads_up || "",
    notes: notes || "",
    alerts_placed: alerts_placed,
    max_stop_price: max_stop_price,
    size: size,
    max_loss: max_loss,
    technical_stop: technical_stop,
    exit_target: exit_target,
    time_stop: time_stop || "",
    risk_or_reward: `${otp[0]}:${otp[1]}` || "",
    system_rules: system_rules,
    result_in_fear: result_in_fear,
    greed_or_pride: greed_or_pride,
  };

  const idToken = useSelector((state) => state.auth.idToken);
  const dispach = useDispatch();
  const handleEntry = (select) => {
    setEntry(options3[select.value]);
  };
  const navigate = useNavigate();
  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = async () => {
    setIsSpinner(true);

    try {
      if (rowData) {
        const Id = rowData?.id;
        if (rowData?.action) {
          const res = await createJournalTraderRequest(idToken, data);
          if (res?.status === 201 || 200) {
            const msg = `Successfully created trade journal`;
            const status = res.status;
            dispach(returnMessages(msg, status));
            setIsSpinner(false);
            navigate("/trademate/trade-journal");
            const tradeList = await getTraderJournalRequest(idToken);
            dispach(getTraderJournalSuccess(tradeList));
          } else if (res?.response?.data) {
            const msg = "Fill the mandatory fields";
            const status = res?.response?.status;
            dispach(returnErrors(msg, status));
            setIsSpinner(false);
          }
        } else {
          const res = await updateJournalTraderRequest(idToken, data, Id);
          if (res?.status === 200) {
            const msg = `Successfully Updated trade journal`;
            const status = res.status;
            dispach(returnMessages(msg, status));
            setIsSpinner(false);
            navigate("/trademate/trade-journal");
            const tradeList = await getTraderJournalRequest(idToken);
            dispach(getTraderJournalSuccess(tradeList));
          } else if (res?.response?.data) {
            const msg = "Fill the mandatory fields";
            const status = res?.response?.status;
            dispach(returnErrors(msg, status));
            setIsSpinner(false);
          }
        }
      } else {
        const res = await createJournalTraderRequest(idToken, data);

        if (res.status === 201) {
          const msg = "Successfully created trade journal";
          const status = res.status;
          dispach(returnMessages(msg, status));
          setIsSpinner(false);
          navigate("/trademate/trade-journal");
          const tradeList = await getTraderJournalRequest(idToken);
          dispach(getTraderJournalSuccess(tradeList));
        } else if (res?.response?.data) {
          const msg = "Fill the mandatory fields";
          const status = res?.response?.status;
          dispach(returnErrors(msg, status));
          setIsSpinner(false);
        }
      }
    } catch (error) {
      if (error) {
        const msg = "Something Erorr";
        const status = 500;
        dispach(returnErrors(msg, status));
        setIsSpinner(false);
      }
    }
  };
  // const [error, setError] = useState("");

  // const handleRiskorReward = (value) => {
  //   const ratioRegex = /^\d+:\d+$/;

  //   if (!ratioRegex.test(value)) {
  //     setError('Invalid format. Please use the format "1:2".');
  //   } else {
  //     setError("");
  //   }

  //   setRisk_or_reward(value);
  // };
  const navigation = [
    {pathName: tableDatas.state?.update === false ? "Trading History" : "Trade Journal", link: tableDatas.state?.update === false ? "/account-metrics/trading-journal" : "/trademate/trade-journal"},
    {pathName: "Create Journal", link: "/trademate/create-trade"},
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CustomSeparator navigation={navigation} />
      <LayoutBox className="trademate-container ">
        <Card className="tradingactivity-container_trademate">
          <div className="create_trade_jorunal">
            {/* Heading */}
            <div className="create_trade_heading">
              <h2>Create Trade Journal</h2>
            </div>
            <div className="create_journal_body">
              {/* First Div */}
              <div className="create_tarde_first">
                <p>Create a journal by filling the details</p>
                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, velit.</p> */}
              </div>
              <div className="create_jorunal_main">
                <div className="main_conatiner">
                  <div className="create_jorunal_main">
                    <div className="create_first">
                      <div className="date_conatiner">
                        <div className="App">
                          <div className="date_conatiner">
                            <div>
                              <p className="journal_label">Date:-</p>
                            </div>
                            <div className="inputField">
                              <DatePicker
                                selected={date}
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                placeholderText="Select date"
                                onChange={handleChange}
                                className="date_time"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="calendar-button"
                          onClick={() => {
                            setIsCalender((prev) => !prev);
                          }}
                        ></div>
                        {/* <div className="calendar_wrapper_journal">
                        {isCalender && (
                          <Calendar
                            onClick
                            onChange={(selectedDate) => handleDateChange(selectedDate)}
                            value={date}
                            // selectRange={true}
                          />
                        )}
                      </div> */}
                      </div>

                      <div className="drop-selector">
                        <label
                          htmlFor="type"
                          className="journal_label"
                        >
                          Trade Type
                        </label>
                        <Select
                          options={options}
                          styles={customStyles}
                          value={tradeType}
                          onChange={handleTradeType}
                          menuStyle={{width: "100%", zIndex: "100"}}
                          className="Select"
                        />
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Entry</p>
                        </div>
                        {/* <div className="sell_buy">
                          <input
                            type="text"
                            id="Profit"
                            name="symbol"
                            className="inputField"
                            value={entry}
                            onChange={(e) => setEntry(e.target.value)}
                            placeholder="Enter Entry"
                          />
                        </div> */}
                        <Select
                          options={options3}
                          value={entry}
                          styles={customStyles}
                          onChange={handleEntry}
                          menuStyle={{width: "100%", zIndex: "100"}}
                          className="Select"
                        />
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Heads Up</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={heads_up}
                            onChange={(e) => setHeads_up(e.target.value)}
                            placeholder="Heads Up"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Notes</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Notes"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Alerts Placed</p>
                        </div>
                        {/* <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={alerts_placed}
                            onChange={(e) => setAlerts_placed(true)}
                            placeholder="Enter symbol"
                          />
                        </div> */}
                        <div className="radio_container">
                          <label>
                            <input
                              type="radio"
                              name="trade"
                              id=""
                              value={"Yes"}
                              onChange={(e) => setAlerts_placed(true)}
                            />
                            <span> Yes</span>
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="trade"
                              id=""
                              value={"No"}
                              onChange={(e) => setAlerts_placed(false)}
                            />
                            <span> No</span>
                          </label>
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Max Stop Price</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={max_stop_price}
                            onChange={(e) => setMax_stop_price(e.target.value)}
                            placeholder="Max Stop Price"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Max Loss</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={max_loss}
                            onChange={(e) => setMax_loss(e.target.value)}
                            placeholder="Max Loss"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Technical Stop</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={technical_stop}
                            onChange={(e) => settechnical_stop(e.target.value)}
                            placeholder="Technical Stop"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Exit Target</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={exit_target}
                            onChange={(e) => setexit_target(e.target.value)}
                            placeholder="Exit Target"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Exit Target</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="Exit Target"
                            name="Exit Target"
                            className="inputField"
                            value={exit_target}
                            onChange={(e) => setexit_target(e.target.value)}
                            placeholder="Enter Exit Target"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Risk Or Reward</p>
                        </div>
                        <div className="sell_buy">
                          {/* <input
                            type="text"
                            id="symbol"
                            name="risk_or_reward"
                            className="inputField"
                            value={risk_or_reward}
                            onChange={(e) => handleRiskorReward(e.target.value)}
                            placeholder="Enter symbol"
                          />
                          {error && <div style={{color: "#ff0006"}}>{error}</div>} */}
                          <div style={{display: "flex", alignItems: "center", marginTop: "10px", gap: "5px"}}>
                            {otp.map((digit, index) => (
                              <>
                                <input
                                  key={index}
                                  type="text"
                                  value={digit}
                                  className="inputField"
                                  onChange={(e) => handleInputChange(index, e.target.value)}
                                  maxLength="3"
                                  style={{
                                    // width: "40px",
                                    // height: "40px",
                                    borderRadius: "1rem",
                                    textAlign: "center",
                                    fontSize: "16px",
                                    margin: "0 5px",
                                  }}
                                  required
                                />
                                <p>{index === 0 ? ":" : null}</p>
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="create_secound">
                      <div className="drop-selector">
                        <label
                          htmlFor="type"
                          className="journal_label"
                        >
                          Symbol
                        </label>
                        {/* <Select
                          options={options2}
                          value={symbol}
                          styles={customStyles}
                          onChange={"handleEntry"}
                          menuStyle={{width: "100%", zIndex: "100"}}
                          className="Select"
                        /> */}
                        <input
                          type="text"
                          id="Symbol"
                          name="Symbol"
                          className="inputField"
                          value={symbol}
                          onChange={(e) => setSymbol(e.target.value)}
                          placeholder="Symbol"
                        />
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Trigger</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={trigger}
                            onChange={(e) => setTrigger(e.target.value)}
                            placeholder="Trigger"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Supporting Evidence</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={supporting_evidence}
                            onChange={(e) => setSupporting_evidence(e.target.value)}
                            placeholder="Supporting Evidence"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Opposing Evidence</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="text"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={opposing_evidence}
                            onChange={(e) => setOpposing_evidence(e.target.value)}
                            placeholder="Opposing Evidence"
                          />
                        </div>
                      </div>
                      <div className="radio_conatiner">
                        <p>Is this a counter trend trade?</p>
                        <div className="radio_container">
                          <label>
                            <input
                              type="radio"
                              name="trade"
                              id=""
                              value={"Yes"}
                              onChange={(e) => setCounterTrend(e.target.value)}
                            />
                            <span> Yes</span>
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="trade"
                              id=""
                              value={"No"}
                              onChange={(e) => setCounterTrend(e.target.value)}
                            />
                            <span> No</span>
                          </label>
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Order Price</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="Order Price"
                            name="Order Price"
                            className="inputField"
                            value={orderPrice}
                            onChange={(e) => setOrderPrice(e.target.value)}
                            placeholder="Order Price"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Profit</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="Profit"
                            name="Profit"
                            className="inputField"
                            value={profit}
                            onChange={(e) => setProfit(e.target.value)}
                            placeholder="Profit"
                          />
                        </div>
                      </div>

                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">System Rules</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="System Rules"
                            name="System Rules"
                            className="inputField"
                            value={system_rules}
                            onChange={(e) => setsystem_rules(e.target.value)}
                            placeholder="System Rules"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Result in Fear</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="Result in Fear"
                            name="Result in Fear"
                            className="inputField"
                            value={result_in_fear}
                            onChange={(e) => setresult_in_fear(e.target.value)}
                            placeholder="Result in Fear"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Greed Or Pride</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="number"
                            id="Greed Or Pride"
                            name="Greed Or Pride"
                            className="inputField"
                            value={greed_or_pride}
                            onChange={(e) => setgreed_or_pride(e.target.value)}
                            placeholder="Greed Or Pride"
                          />
                        </div>
                      </div>
                      <div className="sell_buy">
                        <div>
                          <p className="journal_label">Time Stop</p>
                        </div>
                        <div className="sell_buy">
                          <input
                            type="time"
                            id="symbol"
                            name="symbol"
                            className="inputField"
                            value={time_stop}
                            onChange={(e) => setTime_stop(e.target.value)}
                            placeholder="Time Stop"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="create_button">
                    <button
                      onClick={handleSubmit}
                      disabled={isSpinner}
                    >
                      {isSpinner ? <Spinner /> : tableDatas.state?.update === true ? "Update Trade Journal " : "Create Trade"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </LayoutBox>
    </>
  );
};

export default CreateTradeJournal;
